// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UgZEs","type":"styles_type__16akv","choices":"styles_choices__3-aN6"};